import { zone } from "@smart/bridge-resources-basic";
import { buildCloudfrontDef } from "@smart/itops-constructs-basic";
import { buildNamespace } from "@smart/itops-types-basic";

import { system } from "./base";

export const cdn = buildCloudfrontDef({
  zone,
  namespace: buildNamespace({ system, entity: "manage" }),
  subdomain: "app",
  fallbackRoute: "index.html",
  viewerRequestFunction: `
function handler(event) {
  var request = event.request;
  // The uri doesn't include the query string
  var uri = request.uri;

  // If there's no dot anywhere, assume SPA route
  if (uri.indexOf('.') === -1) {
    request.uri = '/index.html';
  }

  return request;
}
  `.trim(),
  errorCachingTtl: 0,
});
